import type { TranslateDictionary } from './en.js';

export const Vi: TranslateDictionary = {
  'Start airplay': 'Bắt đầu AirPlay',
  'Stop airplay': 'Dừng AirPlay',
  Audio: 'Âm thanh',
  Captions: 'Phụ đề',
  'Enable captions': 'Bật phụ đề',
  'Disable captions': 'Tắt phụ đề',
  'Start casting': 'Bắt đầu truyền',
  'Stop casting': 'Dừng truyền',
  'Enter fullscreen mode': 'Xem toàn màn hình',
  'Exit fullscreen mode': 'Thoát toàn màn hình',
  Mute: 'Tắt tiếng',
  Unmute: 'Bật tiếng',
  'Enter picture in picture mode': 'Bật chế độ hình trong hình',
  'Exit picture in picture mode': 'Thoát chế độ hình trong hình',
  Play: 'Phát',
  Pause: 'Tạm dừng',
  'Playback rate': 'Tốc độ phát',
  'Playback rate {playbackRate}': 'Tốc độ phát {playbackRate}',
  Quality: 'Chất lượng',
  'Seek backward': 'Tua lại',
  'Seek forward': 'Tua đi',
  Settings: 'Cài đặt',
  Auto: 'Tự động',
  'audio player': 'trình phát âm thanh',
  'video player': 'trình phát video',
  volume: 'Âm lượng',
  seek: 'Tìm kiếm',
  'closed captions': 'Phụ đề',
  'current playback rate': 'tốc độ phát hiện tại',
  'playback time': 'thời gian phát',
  'media loading': 'đang tải phương tiện',
  settings: 'Cài đặt',
  'audio tracks': 'bản âm thanh',
  quality: 'Chất lượng',
  play: 'phát',
  pause: 'tạm dừng',
  mute: 'tắt tiếng',
  unmute: 'bật tiếng',
  'chapter: {chapterName}': 'chương: {chapterName}',
  live: 'trực tiếp',
  Off: 'Tắt',
  'start airplay': 'bắt đầu AirPlay',
  'stop airplay': 'dừng AirPlay',
  'start casting': 'bắt đầu truyền',
  'stop casting': 'dừng truyền',
  'enter fullscreen mode': 'xem toàn màn hình',
  'exit fullscreen mode': 'thoát toàn màn hình',
  'enter picture in picture mode': 'bật chế độ hình trong hình',
  'exit picture in picture mode': 'thoát chế độ hình trong hình',
  'seek to live': 'chuyển đến phát trực tiếp',
  'playing live': 'đang phát trực tiếp',
  'seek back {seekOffset} seconds': 'tua lại {seekOffset} giây',
  'seek forward {seekOffset} seconds': 'tua đi {seekOffset} giây',
  'Network Error': 'Lỗi mạng',
  'Decode Error': 'Lỗi giải mã',
  'Source Not Supported': 'Nguồn không được hỗ trợ',
  'Encryption Error': 'Lỗi mã hóa',
  'A network error caused the media download to fail.':
    'Lỗi mạng khiến tải xuống phương tiện thất bại.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Lỗi phương tiện khiến phát lại bị hủy. Phương tiện có thể bị hỏng hoặc trình duyệt của bạn không hỗ trợ định dạng này.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Đã xảy ra lỗi không được hỗ trợ. Máy chủ hoặc mạng bị lỗi, hoặc trình duyệt của bạn không hỗ trợ định dạng này.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Phương tiện được mã hóa và không có khóa để giải mã.',
};
